__webpack_require__.p = "/ParrotTale/";